import React, { Component } from "react";
import { Alert, Table, Badge } from "reactstrap";
import ModalForm from "../Modals/Modal";
import ModalForm2 from "../Modals/Modal2";
import moment from "moment";

class DataTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      REQUESTOR_AUTHORIZED: "",
      totalRows: "",
      tableRows: "",
    };
  }

  componentDidMount() {
    const tableRows = document.getElementById("dataTable").rows.length - 2;
    this.setState({ totalRows: tableRows });
    //console.log("Table mounted. Total rows=" + tableRows);
  }

  componentDidUpdate() {
    const tableRows = document.getElementById("dataTable").rows.length - 2;
    //console.log("Table Updated. Total Row Count now= " + tableRows);
    //console.log("Current total row state = " + this.state.totalRows);

    if (this.state.totalRows !== tableRows) {
      this.setState({ totalRows: tableRows });
      //console.log("updating table rows");
    }
  }

  render() {
    //console.log("Items list is" + itemList);
    const items = this.props.items.map((item) => {
      // Set Delivery Method
      let DELIVERY_METHOD_MAIL = item.MAIL_RESPONSE_FLAG;
      let DELIVERY_METHOD_EMAIL = item.EMAIL_RESPONSE_FLAG;
      let FORMAT_DOB = moment(item.REQUESTOR_DOB).format("M/D/YYYY");
      let FORMAT_DEPENDENT_DOB = moment(item.DEPENDENT_DOB).format("M/D/YYYY");
      let FORMAT_REQUEST_DATE = moment(item.REQUEST_DATE).format("M/D/YYYY");
      let DELIVERY_METHOD = "";
      if (DELIVERY_METHOD_MAIL === 1) {
        DELIVERY_METHOD = "Mail";
      } else if (DELIVERY_METHOD_EMAIL === 1) {
        DELIVERY_METHOD = "Email";
      }

      return (
        <tr key={item.id}>
          <th scope="row">{item.REQUEST_ID}</th>
          <td>
            <React.Fragment>
              <h2>
                {" "}
                {item.REQUESTOR_FIRST_NAME} {item.REQUESTOR_LAST_NAME}
              </h2>
              <h3> {FORMAT_DOB}</h3>
              <h3> {item.REQUESTOR_PHONE_NUMBER}</h3>
            </React.Fragment>
          </td>
          <td>
            <React.Fragment>
              {(() => {
                if (
                  item.DEPENDENT_FIRST_NAME !== null &&
                  item.DEPENDENT_LAST_NAME !== null
                ) {
                  return (
                    "Name:" +
                    item.DEPENDENT_FIRST_NAME +
                    " " +
                    item.DEPENDENT_LAST_NAME
                  );
                }
              })()}
              <br />
              {(() => {
                if (item.DEPENDENT_DOB !== null) {
                  return "DOB:" + FORMAT_DEPENDENT_DOB;
                }
              })()}
            </React.Fragment>
          </td>
          <td>{FORMAT_REQUEST_DATE}</td>
          <td>
            {(() => {
              if (item.RESPONSE_STATUS === "PENDING_IDENTIFICATION") {
                return (
                  <React.Fragment>
                    <h5>
                      <Badge color="warning">Verification Needed</Badge>
                    </h5>
                  </React.Fragment>
                );
              } else if (item.RESPONSE_STATUS === "VERIFIED") {
                return (
                  <React.Fragment>
                    <h5>
                      <Badge color="light">Verified</Badge>
                    </h5>
                  </React.Fragment>
                );
              } else if (item.RESPONSE_STATUS === "PDF_GENERATED") {
                return (
                  <React.Fragment>
                    <h5>
                      <Badge color="light">Letter Created</Badge>
                    </h5>
                  </React.Fragment>
                );
              } else {
                return (
                  <React.Fragment>
                    <h5>
                      <Badge color="light">New</Badge>
                    </h5>
                  </React.Fragment>
                );
              }
            })()}
          </td>
          <td>
            {(() => {
              if (item.RESPONSE_TYPE === "PIR_RESPONSE") {
                return (
                  <React.Fragment>
                    <h5>
                      <Badge color="info">Information</Badge>
                    </h5>
                  </React.Fragment>
                );
              } else if (item.RESPONSE_TYPE === "DELETE_RESPONSE") {
                return (
                  <React.Fragment>
                    <h5>
                      <Badge color="danger">Delete</Badge>
                    </h5>
                  </React.Fragment>
                );
              } else if (item.RESPONSE_TYPE === "OPT_OUT_RESPONSE") {
                return (
                  <React.Fragment>
                    <h5>
                      <Badge color="warning">Do Not Sell</Badge>
                    </h5>
                  </React.Fragment>
                );
              } else if (item.RESPONSE_TYPE === "DO_NOT_SHARE") {
                return (
                  <React.Fragment>
                    <h5>
                      <Badge color="light">Do Not Share</Badge>
                    </h5>
                  </React.Fragment>
                );
              } else if (item.RESPONSE_TYPE === "CORRECT_PI") {
                return (
                  <React.Fragment>
                    <h5>
                      <Badge color="primary">Correct PI</Badge>
                    </h5>
                  </React.Fragment>
                );
              }
            })()}
          </td>
          <td>
            <h5>
              <Badge color="light">{DELIVERY_METHOD}</Badge>
            </h5>
          </td>
          <td>
            <ModalForm buttonLabel="Notes" item={item} />{" "}
          </td>
          <td>
            {(() => {
              if (item.RESPONSE_ID === null) {
                return (
                  <React.Fragment>
                    <Alert color="warning">
                      Not Available Until Weekly
                      <br /> Batch Process is Complete
                    </Alert>
                  </React.Fragment>
                );
              } else {
                return (
                  <React.Fragment>
                    <ModalForm2 buttonLabel="Request Extension" item={item} />{" "}
                  </React.Fragment>
                );
              }
            })()}
          </td>
        </tr>
      );
    });

    const rowCount = this.state.totalRows;

    const footerTH = { minWidth: "175px" };
    return (
      <Table id="dataTable" responsive hover>
        <thead>
          <tr>
            <th>Request ID</th>
            <th>Requestor</th>
            <th>Dependent</th>
            <th>Date</th>
            <th>Status</th>
            <th>Types</th>
            <th>Method</th>
            <th></th>
          </tr>
        </thead>
        <tbody>{items}</tbody>
        <tfoot>
          <tr>
            <th scope="row" style={footerTH}>
              <h4>Total Records:</h4>
            </th>
            <td>
              <h4>{rowCount}</h4>
            </td>
          </tr>
        </tfoot>
      </Table>
    );
  }
}

DataTable.defaultProps = {
  labels: "verify-",
  name: "",
  id: "",
  value: "",
  placeholder: "",
  onChange: () => {},
  onBlur: () => {},
  onKeyDown: () => {},
};

export default DataTable;
